/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './spinner.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../app/spinner/spinner.component';
const styles_SpinnerComponent:any[] = [import0.styles];
export const RenderType_SpinnerComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_SpinnerComponent,
  data: {}
}
);
export function View_SpinnerComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'spinnercontainer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'spinner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'double-bounce1'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'double-bounce2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import2.SpinnerComponent = v.component;
    const currVal_0:boolean = !co.isDelayedRunning;
    ck(v,0,0,currVal_0);
  });
}
function View_SpinnerComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-spinner',([] as any[]),(null as any),(null as any),(null as any),View_SpinnerComponent_0,RenderType_SpinnerComponent)),
    import1.ɵdid(180224,(null as any),0,import2.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const SpinnerComponentNgFactory:import1.ComponentFactory<import2.SpinnerComponent> = import1.ɵccf('app-spinner',import2.SpinnerComponent,View_SpinnerComponent_Host_0,{
  delay: 'delay',
  isRunning: 'isRunning'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zcGlubmVyL3NwaW5uZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zcGlubmVyL3NwaW5uZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL3NwaW5uZXIvc3Bpbm5lci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zcGlubmVyL3NwaW5uZXIuY29tcG9uZW50LnRzLlNwaW5uZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IFtoaWRkZW5dPVwiIWlzRGVsYXllZFJ1bm5pbmdcIj5cclxuICAgIDxkaXYgY2xhc3M9XCJzcGlubmVyY29udGFpbmVyXCI+XHJcbiAgICAgICAgPGRpdiBjbGFzcz1cInNwaW5uZXJcIj5cclxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImRvdWJsZS1ib3VuY2UxXCI+PC9kaXY+XHJcbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJkb3VibGUtYm91bmNlMlwiPjwvZGl2PlxyXG4gICAgICAgIDwvZGl2PlxyXG4gICAgPC9kaXY+XHJcbjwvZGl2PlxyXG4iLCI8YXBwLXNwaW5uZXI+PC9hcHAtc3Bpbm5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0FBO1FBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrQztNQUM5QjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQThCO01BQzFCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBcUI7TUFDakI7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrQztNQUNsQztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWtDO0lBQ2hDO0lBQ0o7SUFDSjs7OztJQVBEO0lBQUwsU0FBSyxTQUFMOzs7OztJQ0FBO2dCQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/spinner/spinner.component.ngfactory.ts